export const abonoIds = ['6','19', '10', '14', '21', '31', '34', '36', '39'] //8 /* '9', Credito Consumo: plantilla deshabilitada temporalmente. */ 
export const cargoIds = ['3','20', '5', '11', '12', '15', '16', '17', '18', '38', '22', '28', '29', '30', '33', '35'] //9
export const ajusteIds = ['7', '23', '24', '25', '32', '37']

// Cuentas corrientes y cobro/pago masivo no se crean desde conciliación bancaria.
const excluidasBancoIds = ['19', '20', '32', '37']

export const getPlantillasBanco = (items, tipoMovimiento) => {
  const tipo = String(tipoMovimiento || '').trim().toLowerCase()
  if (!['abono', 'cargo'].includes(tipo)) return []
  const ids = tipo === 'abono' ? abonoIds : [...cargoIds, ...ajusteIds]
  return items.filter(item =>
    !excluidasBancoIds.includes(item.id) &&
    ids.includes(item.id)
  )
}
